/*
  Size finder — storefront sizing logic
  (ModaXpress Size Finder Widget v3.4); only the DOM plumbing and accessibility
  handling were rewritten (focus trap, focus restore, live result announcement).
*/
(function () {
  'use strict';

  if (window.mxsfInit) return;
  window.mxsfInit = true;

  var CHART = [
    { size: 1, wMin: 0, wMax: 115, waistTyp: 27, hips: 34, fit: 'Small' },
    { size: 3, wMin: 115, wMax: 130, waistTyp: 29, hips: 38, fit: 'Small' },
    { size: 5, wMin: 130, wMax: 145, waistTyp: 29, hips: 40, fit: 'Small' },
    { size: 7, wMin: 145, wMax: 155, waistTyp: 32, hips: 40, fit: 'Medium' },
    { size: 9, wMin: 155, wMax: 170, waistTyp: 34, hips: 41, fit: 'Medium' },
    { size: 11, wMin: 170, wMax: 185, waistTyp: 37, hips: 43, fit: 'Large' },
    { size: 13, wMin: 185, wMax: 200, waistTyp: 39, hips: 45, fit: 'Large' },
    { size: 15, wMin: 200, wMax: 215, waistTyp: 41, hips: 48, fit: 'X-Large' },
    { size: 17, wMin: 215, wMax: 9999, waistTyp: 43, hips: 52, fit: 'X-Large' },
  ];
  var WAIST_BUMP_THRESHOLD = 2.5;
  var FOCUSABLE = 'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function chartFor(s) {
    for (var i = 0; i < CHART.length; i++) if (CHART[i].size === s) return CHART[i];
    return null;
  }

  function nextSize(s) {
    for (var i = 0; i < CHART.length; i++) {
      if (CHART[i].size === s) return i < CHART.length - 1 ? CHART[i + 1].size : s;
    }
    return s;
  }

  function prevSize(s) {
    for (var i = 0; i < CHART.length; i++) {
      if (CHART[i].size === s) return i > 0 ? CHART[i - 1].size : s;
    }
    return s;
  }

  function sizeByWeight(lb) {
    if (lb == null) return null;
    for (var i = 0; i < CHART.length; i++) {
      if (lb >= CHART[i].wMin && lb < CHART[i].wMax) return CHART[i].size;
    }
    return lb < CHART[0].wMin ? CHART[0].size : CHART[CHART.length - 1].size;
  }

  function sizeByWaistFallback(w) {
    if (w == null) return null;
    var chosen = CHART[0].size;
    for (var i = 0; i < CHART.length; i++) {
      if (w >= CHART[i].waistTyp - 1.5) chosen = CHART[i].size;
    }
    return chosen;
  }

  function sizeByHipFallback(h) {
    if (h == null) return null;
    var chosen = CHART[0].size;
    for (var i = 0; i < CHART.length; i++) {
      if (h >= CHART[i].hips - 1.5) chosen = CHART[i].size;
    }
    return chosen;
  }

  function init() {
    var overlay = document.getElementById('mxsfOverlay');
    var trigger = document.getElementById('mxsfTrigger');
    if (!overlay || !trigger) return;

    // The overlay is fixed-position; move it out of the sticky product column
    // so ancestor transforms and overflow cannot clip it.
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

    var modal = overlay.querySelector('.mxsf-modal');
    var closeBtn = document.getElementById('mxsfClose');
    var wInput = document.getElementById('mxsfWaist');
    var hInput = document.getElementById('mxsfHips');
    var wtInput = document.getElementById('mxsfWeight');
    var findBtn = document.getElementById('mxsfFind');
    var resultEl = document.getElementById('mxsfResult');
    var resultLbl = document.getElementById('mxsfResultLabel');
    var resultSize = document.getElementById('mxsfResultSize');
    var resultNote = document.getElementById('mxsfResultNote');
    var resultTip = document.getElementById('mxsfResultTip');
    var lastFocused = null;

    function openModal() {
      // Fall back to the trigger when the modal is opened without focus on it.
      lastFocused = document.activeElement && document.activeElement !== document.body ? document.activeElement : trigger;
      overlay.classList.add('mxsf-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      wtInput.focus();
    }

    function closeModal() {
      overlay.classList.remove('mxsf-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      wInput.value = '';
      hInput.value = '';
      wtInput.value = '';
      findBtn.disabled = true;
      resultEl.classList.remove('mxsf-show');
      resultSize.textContent = '';
      resultNote.textContent = '';
      resultTip.textContent = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function trapFocus(event) {
      var focusables = Array.prototype.slice
        .call(modal.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null;
        });
      if (focusables.length === 0) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeModal();
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('mxsf-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'Tab') trapFocus(e);
    });

    function checkReady() {
      findBtn.disabled = !(wInput.value || hInput.value || wtInput.value);
    }

    wInput.addEventListener('input', checkReady);
    hInput.addEventListener('input', checkReady);
    wtInput.addEventListener('input', checkReady);

    findBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var weight = wtInput.value ? parseFloat(wtInput.value) : null;
      var waist = wInput.value ? parseFloat(wInput.value) : null;
      var hips = hInput.value ? parseFloat(hInput.value) : null;

      if (weight == null && waist == null && hips == null) return;

      var size;
      var note = '';
      var tip = '';

      if (weight != null) {
        size = sizeByWeight(weight);
        if (waist != null) {
          var typ = chartFor(size).waistTyp;
          if (waist > typ + WAIST_BUMP_THRESHOLD) {
            size = nextSize(size);
            note = 'Sized up one — waist runs larger than typical for ' + weight + ' lbs.';
          } else {
            note = 'Based on weight and waist.';
          }
        } else {
          note = 'Based on weight. Add waist for a more accurate recommendation.';
        }
      } else if (waist != null) {
        size = sizeByWaistFallback(waist);
        note = 'Based on waist only. Weight is more accurate — please add it.';
      } else {
        size = sizeByHipFallback(hips);
        note = 'Based on hips only — least reliable input.';
      }

      if (size > CHART[0].size) {
        tip = 'Prefer a tighter, more sculpted fit? Try size ' + prevSize(size) + '.';
      }

      var row = chartFor(size);
      resultLbl.textContent = 'Your recommended size is';
      resultSize.textContent = size + ' / ' + (row ? row.fit : '');
      resultNote.textContent = note;
      resultTip.textContent = tip;
      resultEl.classList.add('mxsf-show');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
